import axios from 'axios';
import useSWR from 'swr';

import { formatAndThrowApiError } from '@/helpers/api';

// The latest release of an internal tool, with a download link per computer. The links are
// signed by GitHub and last a few minutes, so a download asks for a fresh one
// (getToolDownloadUrl) rather than using what the page loaded with.
const useToolRelease = (tool) => {
  const swr = useSWR(`/admin/tool-release/${tool}`, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      if (err.response?.status === 404) return null;
      formatAndThrowApiError(err);
    }
  });

  return swr;
};

const getToolDownloadUrl = async (tool, platform) => {
  let result;
  try {
    result = await axios.get(`/admin/tool-release/${tool}`);
  } catch (err) {
    formatAndThrowApiError(err);
  }
  const asset = result.data.assets.find((a) => a.platform === platform);
  if (!asset) throw Error(`No ${platform} download in the latest release`);
  return asset.download_url;
};

export { useToolRelease, getToolDownloadUrl };
